import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, Stack, Box, DialogActions, Link } from '@mui/material';
import { useState } from 'react';
import { ChatBoxHeader, WsButton, WsDialog, WsTypography, WsTypoVariants } from 'wisestep-base';

import InviteUserModal from './InviteUserModal';

export interface IInviteUserButtonProps {
  defaultInvites?: string[];
  onSuccess?: () => void;
  roles?: string[];
  pendingUsersLimit: number;
  maxInvites: number;
}

const InviteUserButton = ({
  defaultInvites = [],
  onSuccess,
  roles,
  pendingUsersLimit,
}: IInviteUserButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [openExpiryModal, setOpenExpiryModal] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => (pendingUsersLimit > 0 ? setOpen(true) : setOpenExpiryModal(true));

  const onExpiryModalClose = () => setOpenExpiryModal(false);

  return (
    <>
      <WsButton startIcon={<Add />} onClick={handleOpen}>
        Invite Users
      </WsButton>
      <InviteUserModal
        open={open}
        handleClose={handleClose}
        onSuccess={onSuccess}
        defaultInvites={defaultInvites}
        pendingUsersLimit={pendingUsersLimit}
        roles={roles}
      />
      <WsDialog size="sm" openDialog={openExpiryModal} onClose={onExpiryModalClose}>
        <ChatBoxHeader>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} display="inline" bold={true}>
            Invite User
          </WsTypography>
          <CloseIcon
            sx={{ cursor: 'pointer', float: 'right', mt: 0.5 }}
            fontSize={'small'}
            onClick={onExpiryModalClose}
          />
        </ChatBoxHeader>
        <DialogContent>
          <Stack spacing={1}>
            <Box>
              <WsTypography display="inline">
                {`You have reached the Limit for Maximum Paid User Licenses. Please add more User
                Licenses to your Plan from "Your Plan" page or contact our team on`}
              </WsTypography>
              <Link href="mailto:support@wisestepmail.com"> support@wisestepmail.com </Link>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <WsButton variant="outlined" onClick={onExpiryModalClose}>
            Close
          </WsButton>
        </DialogActions>
      </WsDialog>
    </>
  );
};

export default InviteUserButton;
